(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smp-why"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var d = document.querySelector('main[data-template^="collection"] [class*="__text_twGGkJ"]');
    if (!d || d.dataset.smpMore) return; d.dataset.smpMore = '1';
    if (window.innerWidth > 760) return;
    if (d.scrollHeight <= d.clientHeight + 8) { d.classList.add('smp-short'); return; }
    var b = document.createElement('button'); b.type = 'button'; b.className = 'smp-more'; b.textContent = 'Skaityti daugiau';
    b.addEventListener('click', function () { var o = d.classList.toggle('smp-open'); b.textContent = o ? 'Rodyti mažiau' : 'Skaityti daugiau'; });
    d.insertAdjacentElement('afterend', b);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();
})();
